<template>

  <div v-if="deviceList.length" class="p-2">
    <div>
        <span class="text-lg py-2">Number of results: {{deviceList.length}}.</span><br/>
        <span class="text-sm italics py-2">Devices per page: </span>

        <span class="btn-group py-2">
            <!-- button class="btn btn-disabled" href="#" tabindex="-1" aria-disabled="true">Devices per page:</button -->
            <button class="btn btn-xs" :class="{ 'btn-active': 15 === perPage }" @click="setResultsPerPage(15)">15</button>
            <button class="btn btn-xs" :class="{ 'btn-active': 30 === perPage }" @click="setResultsPerPage(30)">30</button>
            <button class="btn btn-xs" :class="{ 'btn-active': 50 === perPage }" @click="setResultsPerPage(50)">50</button>
            <button class="btn btn-xs" :class="{ 'btn-active': 100 === perPage }" @click="setResultsPerPage(100)">100</button>
        </span>

        <!-- inspired by: https://codesandbox.io/s/9440e?file=/src/App.vue -->

        <ul>
          <li class="hover:bg-primary hover:text-white sm:text-md" v-for="(item,index) in paginatedData" :key="index">
            <a @click.prevent="setCurrentDevice(item.wurfl_id)" href="#">
            {{ item.capabilities.brand_name }}  {{ item.capabilities.model_name }} <span v-if="item.capabilities.marketing_name">({{item.capabilities.marketing_name}})</span>
            </a>
            <span v-if="item.secondary_wurflids && item.secondary_wurflids.length > 0">
              [<a href="#" @click.prevent="toggleRelatedDevices(item.wurfl_id)"> &gt; </a>]
              <div :ref="`related${item.wurfl_id}`" style="display:none">
                <span v-for="(wid, deviceidx2) in item.secondary_wurflids" :key="deviceidx2">
                [<a @click.prevent="setCurrentDeviceThroughREST(wid)" href="#">{{deviceidx2}}</a>] &nbsp;
                <br v-if="deviceidx2 != 0 && deviceidx2 % 6 == 0" />
                </span>
              </div>
            </span>
          </li>
        </ul>

        <div class="btn-group py-2" aria-label="Device list pagination">
            <button class="btn btn-xs" @click="backPage">Previous</button>
            <!-- li  v-for="idx in Math.ceil(this.deviceList.length / this.perPage)" :key="idx" class="btn btn-xs" -->
            <button  v-for="idx in subIndex" :key="idx" class="btn btn-xs" @click="goToPage(idx)">{{idx}}</button>
            <button class="btn btn-xs" @click="nextPage">Next</button>
        </div>

        <p class="clear-both py-2" aria-label="Clear all results">
            <button class="btn btn-xs" @click="this.resetStore()">Clear All Results</button>
        </p>
    </div>
  </div>

  <!-- Handle Empty Device List -->
  <!-- Used to be "!deviceList.length && (wurflData.isDesktop || wurflData.isTable || wurflData.isSmartTV)", but why?-->
  <div v-if="!deviceList.length && isQRTarget" class="card w-96 bg-base-100 shadow-xl pb-4">
    <div class="card-body">
      <h2 class="card-title">Hello Visitor! Got a phone?</h2>
      <p>Scan this QR code to browse your phone features</p>
    </div>
    <figure><qrcode-vue :value="qrUrl" :size="280" level="H" /></figure>

    <div v-if="collectDeviceInfo" class="card-body">
      <h2 class="card-title">Mmmm... interesting.</h2>
      <p>We were not able to detect your device make and model.<br/> <a class="underline" href="https://web.wurfl.io/undetected" target="_blank">Would you help us improve?</a>
      </p>
    </div>
  </div>

  <div v-if="!deviceList.length && !isQRTarget"  class="card w-full bg-base-100 shadow-xl pb-4">

    <div v-if="!collectDeviceInfo" class="card-body">
      <h2 class="card-title">Hello {{ wurflData.formFactor }}!</h2>
      <p>You seem to be a nice {{ wurflData.completeDeviceName }}</p>
    </div>


    <div v-if="collectDeviceInfo" class="card-body">
      <h2 class="card-title">Mmmm... interesting.</h2>
      <p>We were not able to detect your device make and model.<br/> <a class="underline" href="https://web.wurfl.io/undetected" target="_blank">Would you help us improve?</a>
      </p>
    </div>


  </div>
</template>

<script>
import {useUiElements} from "./../store/uiElements"
import {mapActions, mapState} from 'pinia'
import QrcodeVue from 'qrcode.vue'
// import axios from "axios"


// I may need this later, as setting up routes for this single use-case seems overkill
// let urlParams = new URLSearchParams(window.location.search);
// console.log(urlParams.has('channel')); // true
// console.log(urlParams.get('channel')); // "MyParam"


export default {

  name: 'DeviceList',
  props: ['wurflData','collectDeviceInfo'],

  data() {
    return {
      qrUrl: '',
      page: 1,
      perPage: 15,
      isQRTarget: false // is the page being generated as the result of scanning the QR code?
      // currentDevice: null
    }
  },

  components: {
      QrcodeVue
  },

  mounted() {

    // console.dir(useUiElements)
    // console.log("baseURL in Pinia", this.baseUrl)
    // console.log("UNIQUE ID", this.uniqueId)

    // build QR code with right URL
    this.qrUrl = window.location.origin + "/?channel=" + this.uniqueId
    console.log(this.qrUrl)

    let urlParams = new URLSearchParams(window.location.search)
    this.isQRTarget = !urlParams.has('channel')
  },


  computed: {

    ...mapState(useUiElements, {
        realBaseUrl: "realBaseUrl",
        uniqueId: "uniqueId",
        deviceList: "deviceList",
        selectedDevice: "selectedDevice",
        setCurrentDeviceObject: "setCurrentDeviceObject"
    }),

    paginatedData() {
      // return this.deviceList;
      return this.deviceList.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },

    subIndex() {
      // in case we have too many elements. We only display 5 elements
      let allElements = Math.ceil(this.deviceList.length / this.perPage);
      if ( allElements < 6) {
        // ex: [1,2,3,4]
        return Array(allElements).fill(0).map((_, i) => i+1);
      }

      let diff = allElements - this.page;

      let myRange = Array(Math.min(6,diff)+1);
      for (let i = 0; i <= Math.min(6,diff); i++) {
            myRange[i] = this.page+i;
      }
      // console.log(myRange);
      return myRange;
      // return Math.min(5, )

    },

  },

  methods: {

    // we need this for our modal
    ...mapActions(useUiElements, ['setCurrentDevice','setCurrentDeviceThroughREST','resetStore', 'setModalAlert']),


    nextPage() {
      if (this.page !== Math.ceil(this.deviceList.length / this.perPage)) {
        this.page += 1
      } else {
        this.setModalAlert("You have reached the end of the list. Sorry!")
      }
    },

    backPage() {
      if (this.page !== 1) {
        this.page -= 1
      } else {
        this.setModalAlert("You have reached the beginning of the list. Sorry!")
      }
    },

    goToPage(numPage) {
      this.page = numPage
    },


    setResultsPerPage(cardinality) {
      this.perPage = cardinality
      this.page = 1
    },


    toggleRelatedDevices(wid) {

      // console.log("toggleRelated clicked.")
      // [0] because there may be multiple elemts with the same ref
      const el = this.$refs["related"+wid][0]
      // el.style.backgroundColor = 'green'
      if (el.style.display == 'block') {
        el.style.display = 'none'
      } else {
        el.style.display = 'block'
      }
    },

  },

  // we watch deviceList. When it's set, we reset pagination to page 1
  watch: {
    deviceList: {
      handler(newVal, oldVal) { // watch it
        this.page = 1
      }
    }
  },


}
</script>
